(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["who-we-are"] && !Shopify.designMode) return;
  try {
    
  let timeline = [
        ['2012', 'Hazel & Olive began'],
        ['2013', 'We moved into our first warehouse'],
        ['2015', 'We moved into a new, larger warehouse'],
        ['2015', 'We first donated free prom and homecoming dresses to girls who don\'t have the funds to buy one (ongoing today)'],
        ['2015', 'We first donated free coats to women in need (ongoing today)'],
        ['2016', 'We built a formula and wellness center for women and children in need in Africa'],
        ['2016<br>& 2017', 'We purchased hundreds of toys and had Santa hand them out'],
        ['2021', 'We moved into an even larger warehouse'],
        ['2021', 'Made Inc 5000']
    ];

  timeline.forEach((e, i) => {

        var newNode = document.createElement('div');
        
        var parentNode = document.querySelector('div.da-story-timeline');

        parentNode.append(newNode);

        document.querySelector('div.da-story-timeline > div:last-child').innerHTML = '<p class=da-date-date>'+ e[0] +'</p><img alt="Heart icon" aria-hidden="true" src=https://cdn.shopify.com/s/files/1/0242/6107/files/Heart.svg?v=1662749376><p class=da-date-text>'+ e[1] +'';

        document.querySelector('div.da-story-timeline > div:last-child').classList.add('da-date');

    });

  

  } catch(e) { console.error(e); }
})();
})();
